/**
 * Global container for the logged in user
 * keeps track of the player id name and the
 * last betAmount
 */
export class MyPlayer {
	id: number
	name: string
	password: string
	fakeJwtToken: string

	constructor() {
		this.id = -1
		this.name = null
		this.password = null
	}

	onLogin(playerId: number, name: string, isReconnecting: boolean) {
		this.id = playerId
		this.name = name
		legacy_ga._trackEvent('client_initiation', 'login_success')
	}
}

export const myPlayer = new MyPlayer()
